
export function setVouchersTypes(state, voucherTypes) {
    state.voucherTypes = voucherTypes
}

export function setReportData(state, data_report) {
    state.data_report = data_report
}
export function setParams(state, params){
    state.params = params
}
export function setBranchParams(state) {
    let branchoffice_id = localStorage.getItem("selected_branchoffice");
    state.paramsVoucherType.branchoffice = branchoffice_id;
}



// WEBPACK FOOTER //
// ./src/modules/accounting-detail/mutations.js